import { render } from "./glob-tabs.vue?vue&type=template&id=52af2d76"
import script from "./glob-tabs.vue?vue&type=script&lang=js"
export * from "./glob-tabs.vue?vue&type=script&lang=js"

import "./glob-tabs.vue?vue&type=style&index=0&id=52af2d76&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__